import React, {useState, useEffect} from 'react'
import Axios from 'axios'
// this file renders img files in a 0x0 div so they don't flicker when are actually used

const ImagePreloader = props => {
    //TODO auto scan public folder for images somehow


    const loadJSON = (url, callback) => {
        //basic ajax get, sends data obj to callback on success
        return Axios.get(url + '?t=' + Date.now()).then(res => {
            if (res.status === 200) {
                return callback(res.data);
            } 
        })
    }
    
    const [publicImages, setPublicImages] = useState(undefined);

    useEffect(()=>{
        loadJSON('./media/media-manifest.json', (data)=>{
            setPublicImages(data.img || [])
        })
    }, [])

    return (
        <div className="ImagePreloader" style={{
            position:'absolute',
            bottom:0,
            left:0,
            width:0,
            height:0,
            pointerEvents:"none",
            overflow:'hidden',
        }}>
            <div className={`images`}>
                {   publicImages && 
                    publicImages.map((image, idx) => {
                        return <img src={image} key={'image'+idx} alt={'image'+idx}/>             
                    })
                }
                {/* <img src={courseBG} alt={'preload'}/> */}
                
            </div>

        </div>
    )
}

export default ImagePreloader